// extracted by extract-css-chunks-webpack-plugin
module.exports = {"shadow":"rDW26","rightShadow":"pPS1a","leftShadow":"Ztr7Q"};